var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useMemo, useState } from 'react';
import { _getContracts } from '@sovryn-zero/lib-ethers/dist/src/EthersLiquityConnection';
import { Decimal } from '@sovryn/utils';
import { getZeroProvider } from '../../../5_pages/ZeroPage/utils/zero-provider';
import { useCall } from '../../../../hooks/useCall';
import { CRITICAL_COLLATERAL_RATIO } from '../constants';
export const useZeroData = (rbtcPrice) => {
    const [isLoading, setIsLoading] = useState(true);
    const [response, getTcr] = useCall(() => __awaiter(void 0, void 0, void 0, function* () {
        setIsLoading(true);
        const { ethers } = yield getZeroProvider();
        const price = rbtcPrice
            ? rbtcPrice
            : yield ethers.getPrice().then(String).then(Decimal.from);
        const contract = _getContracts(ethers.connection).troveManager;
        const liquidationReserve = yield contract
            .ZUSD_GAS_COMPENSATION()
            .then(String)
            .then(Decimal.fromBigNumberString);
        const tcr = yield contract
            .getTCR(price.toBigNumber())
            .then(String)
            .then(Decimal.fromBigNumberString);
        setIsLoading(false);
        return {
            tcr,
            liquidationReserve,
        };
    }), [rbtcPrice], { tcr: Decimal.ZERO, liquidationReserve: Decimal.ZERO });
    useEffect(() => {
        getTcr().catch(console.error);
    }, [getTcr]);
    return useMemo(() => (Object.assign(Object.assign({}, response), { isRecoveryMode: response.tcr.lte(CRITICAL_COLLATERAL_RATIO), isLoading })), [isLoading, response]);
};
